exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vue-book-resize-line {\n  width: 4px;\n  cursor: col-resize;\n}\n.vue-book-resize-line--is-horizontal {\n    cursor: row-resize;\n}\n", ""]);

// exports
